//eslint-disable-next-line @wix/santa-editor/scoped-imports, @typescript-eslint/no-restricted-imports
import '@/rEditor/editor.global.scss';
